export enum GlobalConfigurationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
